import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DashboardServiceService } from '../../services/dashboard-service.service';

@Component({
  selector: 'app-new-future-modal',
  templateUrl: './new-future-modal.component.html',
  styleUrls: ['./new-future-modal.component.css'],
})
export class NewFutureModalComponent implements OnInit {
  value: any;
  no: any = false;
  url = environment.newFutureModal;
  constructor(
    private dialog: MatDialog,
    private dashboardService: DashboardServiceService
  ) {
    //direct login modal
  }

  ngOnInit(): void {
    //
  }

  confirm(): void {
    this.dialog.closeAll();
  }

  onChange(e: any): void {
    this.value = e.target.value;
  }

  //update direct login value through modal directly
  submit() {
    if (!this.value) {
      this.value = false;
    }
    this.dashboardService
      .loginRedirectSetting({ login_directly: this.value })
      .subscribe(() => {
        localStorage.removeItem('redirect');
        localStorage.setItem('redirect', this.value);
        this.dashboardService.settingUpdated('true');
      });
    this.dialog.closeAll();
  }
}
